module.exports = __webpack_public_path__ + "static/media/masked-pipes.1176aab4.gif";